import React from "react";
import styles from "./menu.module.css";

const Menu = ({ setMenuOn, subMenuOn, setSubMenuOn, windowWidth }) => {
  const menu_list = {
    menu_1: {
      menu_title: "회사소개",
      menu_address: "/company/ceo",
      subMenu: [
        ["CEO인사말", "/company/ceo"],
        ["회사소개", "/company/info"],
        ["회사연혁", "/company/history"],
        ["조직구성", "/company/member"],
        ["오시는길", "/company/map"],
      ],
    },
    menu_2: {
      menu_title: "사업소개",
      menu_address: "/business/outline",
      subMenu: [
        ["손해사정개요", "/business/outline"],
        ["손해사정구분", "/business/kind"],
        ["업무 프로세스", "/business/process"],
      ],
    },
    menu_3: {
      menu_title: "인재채용",
      menu_address: "/employ/talent",
      subMenu: [
        ["인재상", "/employ/talent"],
        ["복리후생", "/employ/welfare"],
        ["채용정보", "/employ/recruit"],
        ["채용FAQ", "/employ/faq"],
      ],
    },
    menu_4: {
      menu_title: "고객센터",
      menu_address: "/client/claim",
      subMenu: [
        ["보험금청구", "/client/claim"],
        ["개인정보처리방침", "/client/private"],
      ],
    },
  };

  const handleMouseOver = (idx) => {
    setMenuOn(true);
    windowWidth > 992 ? setSubMenuOn(true) : setSubMenuOn(idx);
  };
  const handleMouseLeave = () => {
    if (windowWidth > 992) {
      setMenuOn(false);
    }
    setSubMenuOn(false);
  };

  return (
    <div className={styles.menu_cont}>
      <ul className={styles.menu_ul}>
        {menu_list &&
          Object.values(menu_list).map((menu_item, menu_idx) => {
            return (
              <div key={menu_idx}>
                <li
                  className={styles.menu_li}
                  onMouseOver={() => handleMouseOver(menu_idx)}
                  onMouseLeave={() => handleMouseLeave()}
                  style={{
                    zIndex: Object.values(menu_list).length - menu_idx + 10,
                  }}
                >
                  <span className={styles.menu_a}>
                    {menu_item["menu_title"]}
                  </span>
                  {windowWidth > 992 ? (
                    <ul
                      className={
                        windowWidth > 992
                          ? subMenuOn
                            ? `${styles.subMenu_ul} ${styles.subMenu_show}`
                            : styles.subMenu_ul
                          : subMenuOn === menu_idx
                          ? `${styles.subMenu_ul} ${styles.subMenu_show}`
                          : styles.subMenu_ul
                      }
                    >
                      {menu_item["subMenu"].map(
                        (subMenu_item, subMenu_item_idx) => {
                          return (
                            <li
                              key={subMenu_item_idx}
                              className={styles.subMenu_li}
                            >
                              <a
                                className={styles.subMenu_a}
                                href={subMenu_item[1]}
                              >
                                {subMenu_item[0]}
                              </a>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                {windowWidth <= 992 ? (
                  <li
                    className={styles.subMenu_li}
                    onMouseOver={() => handleMouseOver(menu_idx)}
                    onMouseLeave={() => handleMouseLeave()}
                    style={{
                      zIndex: Object.values(menu_list).length - menu_idx + 10,
                    }}
                  >
                    <ul
                      className={
                        windowWidth > 992
                          ? subMenuOn
                            ? `${styles.subMenu_ul} ${styles.subMenu_show}`
                            : styles.subMenu_ul
                          : subMenuOn === menu_idx
                          ? `${styles.subMenu_ul} ${styles.subMenu_show}`
                          : styles.subMenu_ul
                      }
                    >
                      {menu_item["subMenu"].map(
                        (subMenu_item, subMenu_item_idx) => {
                          return (
                            <li
                              key={subMenu_item_idx}
                              className={styles.subMenu_li}
                            >
                              <a
                                className={styles.subMenu_a}
                                href={subMenu_item[1]}
                              >
                                {subMenu_item[0]}
                              </a>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </li>
                ) : (
                  ""
                )}
              </div>
            );
          })}
      </ul>
    </div>
  );
};

export default Menu;
